import { useMemo } from 'react';

import { getIcon } from '../utils';

import { HereLayer } from 'common/utils/MapMarker/types';

import { useUserGeoPosition } from 'store/features/user/selectors/useUserGeoPosition';
import { GeoCoords } from 'common/utils/Map';
import { EMPTY_ARRAY } from 'common/constants';

export const useUserGeoMarkersLayer = () => {
  const geoPosition = useUserGeoPosition();
  const data = useMemo(() => (geoPosition ? [geoPosition] : EMPTY_ARRAY), [geoPosition]);

  const hereCarMarkersLayer = useMemo(
    (): HereLayer<GeoCoords[]> => ({
      data,
      name: 'geo-point',
      type: 'marker',
      getCoordinates: ({ data: { lat, lng } }: any) => ({
        latitude: lat,
        longitude: lng
      }),
      getIcon: () => {
        const { url, height, width } = getIcon();

        return {
          url,
          width,
          height,
          anchorY: height,
          anchorX: width / 2
        };
      },
    }),
    [data]
  );

  return hereCarMarkersLayer;
};
